interface SaviyntLogoProps {
  /** Color scheme: "light" uses black wordmark, "dark" uses white wordmark.
   *  The icon is always green in both variants. */
  variant: "light" | "dark";
  /** Optional className for external sizing/styling (e.g., "w-44 h-12") */
  className?: string;
}

export function SaviyntLogo({ variant, className }: SaviyntLogoProps) {
  const src =
    variant === "dark" ? "/saviynt-logo-dark.svg" : "/saviynt-logo-light.svg";

  return (
    <img
      role="img"
      aria-label="Saviynt"
      src={src}
      alt="Saviynt"
      className={className}
    />
  );
}
